import React, { FC, useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axiosInstance from '../../../../../utils/axios';
import AddEdit from '../../../CommonPage/AddEdit';
import { URLS } from '../../../../../utils/constants/urls';
import strings from '../../../../../common/Translation/Translate';
import PageLoader from '../../../../../components/PageLoader';
import { EditOrgMasterDataFormModel } from './EditOrgMasterDataForm';
import { AlertColor } from '@mui/material';
import Notification from '../../../../../components/Notification';

const EditOrgMasterData: FC = () => {
  const { id } = useParams() as any;
  const [pageResponse, setPageResponse] = useState<any>([]);
  const [dataType, setDataType] = useState<string>('text');
  const [inputType, setInputType] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);
  const [message, setMessage] = useState<{
    display: boolean;
    severity: AlertColor | null;
    message: string;
  }>({
    display: false,
    severity: null,
    message: '',
  });

  const closeNotification = (value: boolean) => setMessage(prev => ({ ...prev, display: value }));

  const handleCatch = (error: any) => {
    setMessage({
      display: true,
      severity: 'error',
      message: (error.response.data?.error_description ?? error.response.data.message) ?? error.message,
    });
  };

  const getInitialResponse = useCallback(async () => {
    try {
      const { data } = await axiosInstance.get(`${URLS.orgMasterDataById(id)}?isParent=true`);
      setLoading(false);
      setDataType(data.dataType);
      setInputType(getInputType(data.dataType));

      const val = data.masterDataValue === 'true';
      data.masterDataValue = data.dataType === 'Boolean' ? val : data.masterDataValue;
      setPageResponse(data);
    } catch (error: any) {
      handleCatch(error);
    } finally {
      setLoading(false);
    }
  }, [id]);

  const getInputType = (type: string) => {
    switch (type.toLowerCase()) {
      case 'boolean':
        return 'checkbox';
      default:
        return 'text';
    }
  };

  useEffect(() => {
    getInitialResponse();
  }, [id, getInitialResponse]);

  const pageConfig = {
    title: strings.edit_organization_master_data,
    successMessage: strings.common_update_message,
    addEditApiUrl: `${URLS.orgMasterDataById(id)}?isParent=true`,
    initialApi: `${URLS.orgMasterDataById(id)}?isParent=true`,
    formModel: EditOrgMasterDataFormModel(strings, dataType, inputType),
    navigateToPage: ``,
    isCustomResponse: false,
  };

  return (
    <>
      {loading && <PageLoader />}
      {message.display && (
        <Notification
          isOpen={message.display}
          message={message.message}
          severity={message.severity as AlertColor}
          closeNotification={closeNotification}
          autoHideDuration={2000}
        />
      )}
      <AddEdit pageConfig={pageConfig} pageResponse={pageResponse} />
    </>
  );
};
export default EditOrgMasterData;
